import * as React from "react";
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import {lazyInject} from "@athena-portal/core";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import * as moment from "moment";
import {
    Policy,
} from "@ferry/journey-services";
import {FalconNavigatorHeader, Footer} from "@ferry/portal-core";
import {YourDriveAwayCarCoverPanel} from "./YourDriveAwayCarCoverPanel";
import {
    validPolicy
} from "../../../../CommonFunctions";
import {Types} from "../../../../Types";
import type {ICustomerPortalService} from "../../../../services/ICustomerPortalService";

interface IParams {
    policyNumber: string;
    [key: string]: string | undefined
}

interface IState {
    policy?: Policy,
    policiesProcessed: boolean;
    versionHistory?: Policy[];
}

@authorize
export class YourDriveAwayCarCoverPagePlain extends React.Component<IWithRouterProps<IParams>, IState> {

    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IWithRouterProps<IParams>) {
        super(props);

        this.state = {
            policiesProcessed: false,
        };
    }

    public componentDidMount(): void {
        const policyNumber: string = this.props.params.policyNumber;

        this.pluginTemplates.setPageTitle("Policy summary");

        this.customerPortalService.getPolicy(policyNumber).subscribe((policy: Policy) => {

            this.customerPortalService.getPolicyHistory(policyNumber).subscribe((versions: Policy[]) => {
                this.setState({
                    versionHistory: versions
                })
            });

            this.setState({
                policy,
                policiesProcessed: true
            })
        });
    }

    public render() {
        const {policy, policiesProcessed} = this.state;
        const policyNumber: string = this.props.params.policyNumber;

        if (policy && policiesProcessed) {

            return (
                <React.Fragment>
                    <FalconHeader/>
                    <Overlay show={false}/>
                    <div className="page-contents">
                        <FalconNavigatorHeader
                            back={`/dashboard/driveAway/${policy.policyNumber}`}
                            title={"Your car cover"}
                        />
                        <div className="page-heading-white car-cover-policy-number"><span
                            className="font-weight-light">Policy no: </span>{policyNumber}</div>
                        <br/>

                        {this.renderYourCarCoverPanels()}
                        {this.pluginTemplates.renderBackLink("Back", false, `/dashboard/driveAway/${policy.policyNumber}`)}
                    </div>
                    <Footer/>
                </React.Fragment>
            );
        } else {
            return <Overlay show={true}/>
        }
    }

    private renderYourCarCoverPanels() {
        const {policy} = this.state;
        let currentlyActivePolicy: Policy | undefined;

        if (!policy) {
            return;
        }

        if (moment().isBefore(policy.interaction.headerInfo.startDate) && this.state.versionHistory) {
            currentlyActivePolicy = validPolicy(this.state.versionHistory, policy.policyNumber);
        }

        return (
            <YourDriveAwayCarCoverPanel
                key={policy.policyNumber}
                policy={policy}
                currentlyActivePolicy={currentlyActivePolicy}
                vehicleIndex={0}
            />
        );
    }

}

export const YourDriveAwayCarCoverPage = withRouter(YourDriveAwayCarCoverPagePlain)
